
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chinh-sach",
      function () {
        return require("private-next-pages/chinh-sach/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chinh-sach"])
      });
    }
  